import { BlogSearchCarousel, SearchBlogCarouselProps } from './search';
import { connect } from 'react-redux';
import { articlesResponseSelector } from 'store/state/mutationsResponse/selectors';
import { State } from 'store/state';
import { createSelector } from 'reselect';
import withEvents from 'analytics/withEvents';

export const commercialArticlesSelector = createSelector([
  (state: State) => articlesResponseSelector(state, 'searchCommercial'),
], (v) => (v && v.data && v.data.getArticles) || []);

const commercialArticlesLoadingSelector = createSelector([
  (state: State) => articlesResponseSelector(state, 'searchCommercial'),
], (v) => v && v.loading);

export const residentialArticlesSelector = createSelector([
  (state: State) => articlesResponseSelector(state, 'searchResidential'),
], (v) => (v && v.data && v.data.getArticles) || []);

const residentialArticlesLoadingSelector = createSelector([
  (state: State) => articlesResponseSelector(state, 'searchResidential'),
], (v) => v && v.loading);

const BlogSectionWithEvents = withEvents<SearchBlogCarouselProps>(sendEvent => ({
  onCarouselScroll: (direction: 'left' | 'right', isMobile: boolean) => sendEvent('article_carousel_scroll', 'article', {
    event: {
      direction,
      action: isMobile ? 'swipe' : 'click',
    },
  }),
}))(BlogSearchCarousel);

const commercialMapStateToProps = (state: State) => ({
  articles: commercialArticlesSelector(state),
  loading: commercialArticlesLoadingSelector(state),
});

const residentialMapStateToProps = (state: State) => ({
  articles: residentialArticlesSelector(state),
  loading: residentialArticlesLoadingSelector(state),
});

export const CommercialBlog = connect(commercialMapStateToProps)(BlogSectionWithEvents);
export const ResidentialBlog = connect(residentialMapStateToProps)(BlogSectionWithEvents);
